import React from "react";

import LinkSidebar from "@Shared/Components/LinkSidebar/LinkSidebar";
import SidebarTransition from "@Shared/Components/MacroSidebar/SidebarTransition";

const LinkSidebarTransition = ({ isOpen, setIsOpen, value, onChange }) => (
  <SidebarTransition
    isOpen={isOpen}
    position="right"
    close={() => setIsOpen(false)}
    width={400}
    containerStyles={{ top: "75px" }}
    additionalStyle={{
      padding: "0 13px 0 0",
    }}
    shouldHideScrollbar={!isOpen}
  >
    <LinkSidebar value={value} setValue={onChange} />
  </SidebarTransition>
);

export default LinkSidebarTransition;
